import { observer } from "mobx-react-lite";
import React, { useContext } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import ProjectCreate from '../../scene-pm/Projects/ProjectCreate/ProjectCreate';
import Projects from '../../scene-pm/Projects/ProjectsList/Projects';
import ProjectView from '../../scene-pm/Projects/ProjectView/ProjectView';
import Unauthorized from '../common/Unauthorized/Unauthorized';
import { RootStoreContext } from '../stores/rootStore';

const AppDefault = () => {

  const rootStore = useContext(RootStoreContext);
  const { user } = rootStore.userStore;

  if (user.roles.includes("projectManager")) {
    return (
      <div className='flex flex-column' style={{ height: "100vh", minHeight: 0 }}>
        <div className='flex ml-3 mr-3 fadein animation-duration-1000' style={{ flex: 1, minHeight: 0 }}>
          <Routes>
            <Route index element={<Projects />} />
            {/* Redirect old /project/ list to / */}
            <Route path={"project/"} element={<Navigate to="/pm/" replace />} />
            <Route path={"project/new/"} element={<ProjectCreate />} />
            <Route path={"project/:id/*"} element={<ProjectView />} />
          </Routes>
        </div>
      </div>
    )
  }

  return <div className='flex m-7 p-7'><Unauthorized /></div>


}

export default observer(AppDefault)